import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async configuracion(configuracion, silent403 = false) {
    const response = await api.post(API_URL + "configuracion", configuracion, { _silent403: silent403 });
    if (response.data) return response.data;
  },

  async guardaConfiguracion(configuracion) {
    const response = await api.post(API_URL + "guardaConfiguracion", configuracion);
    if (response.data) return response.data;
  },

  async lanzaValidacionMovil(configuracion) {
    const response = await api.post(API_URL + "lanzaValidacionMovil", configuracion);
    return response.data;
  },

  async resetSistema() {
    const response = await api.post(API_URL + "resetSistema", {});
    return response.data;
  },

  async backupBd() {
    return await api.post(API_URL + "backup-bd", {}, { responseType: "blob" });
  },

  async syncProdEstado() {
    const res = await api.post(API_URL + "sync-prod/estado", {}, { _silent403: true });
    return res.data;
  },

  async syncProdCredenciales(datos) {
    const res = await api.post(API_URL + "sync-prod/credenciales", datos);
    return res.data;
  },

  async syncProdImportar(tablas) {
    const res = await api.post(API_URL + "sync-prod/importar", { tablas });
    return res.data;
  },
  async syncProdLimpiar() {
    const res = await api.post(API_URL + "sync-prod/limpiar");
    return res.data;
  },

  async logsGuardar(archivo, contenido) {
    const res = await api.post(API_URL + "sync-prod/logs-guardar", { archivo, contenido });
    return res.data;
  },

  async logsProxy(urlProd, tokenProd, archivo = null) {
    const payload = { url_prod: urlProd, token_prod: tokenProd };
    if (archivo) payload.archivo = archivo;
    const res = await api.post(API_URL + "sync-prod/logs-proxy", payload);
    return res.data;
  },
};
